import { css } from "@compiled/react";

import { TypographyStyles } from "@/libraries/wpl/foundations/src";

type TextAlignment = "left" | "center" | "right";

export interface UniformTextProps {
    text: string;
    style:
        | "body-lg"
        | "body-md"
        | "body-sm"
        | "body-lg bold"
        | "body-md bold"
        | "body-sm bold"
        | "card-title"
        | "card-title-sm"
        | "fine-print"
        | "eyebrow-lg"
        | "eyebrow-md"
        | "eyebrow-sm"
        | "callout"
        | "callout-lg";
    alignment?: TextAlignment;
}

const UniformText = ({
    text,
    style = "body-lg",
    alignment = "left"
}: UniformTextProps) => {
    const alignmentStyle = css({
        textAlign: alignment as TextAlignment
    });
    const boldStyling = css({
        "&.bold": {
            fontWeight: 700
        }
    });
    const resetMargin = css({
        margin: 0
    });

    return (
        <TypographyStyles>
            <p
                className={style as string}
                css={[
                    style.includes("bold") && boldStyling,
                    resetMargin,
                    alignmentStyle
                ]}
            >
                {text}
            </p>
        </TypographyStyles>
    );
};

export default UniformText;
